import { render, staticRenderFns } from "./Related_request.vue?vue&type=template&id=15bb410f&scoped=true"
import script from "./Related_request.vue?vue&type=script&lang=js"
export * from "./Related_request.vue?vue&type=script&lang=js"
import style0 from "./Related_request.vue?vue&type=style&index=0&id=15bb410f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bb410f",
  null
  
)

export default component.exports